var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0653 0.186196C9.64108 0.379112 9.29612 0.709741 9.09151 1.12472L0.202032 19.1536C-0.295014 20.1617 0.159499 21.36 1.18814 21.8196L1.36095 21.8877C1.88618 22.0678 2.46769 22.0309 2.96768 21.7798L11.0066 17.742L19.0349 21.7677C20.0151 22.2592 21.2273 21.9014 21.7563 20.9452C22.0684 20.3812 22.0823 19.7046 21.7933 19.1287L12.7533 1.11245C12.2628 0.135074 11.0645 -0.268176 10.0653 0.186196ZM10.9259 1.99983C10.9469 1.99954 10.9641 2.00621 10.9657 2.00941L19.9856 19.985L19.9639 19.9876C19.9532 19.9873 19.9418 19.9851 19.9313 19.9799L11.455 15.7298C11.1727 15.5883 10.8402 15.5884 10.558 15.7301L2.07014 19.9925L2.03758 20L2.01659 19.995L10.8853 2.00919C10.8839 2.01199 10.8859 2.01014 10.8932 2.00679L10.9259 1.99983Z",
    fill: "#78264F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.68c3e990.svg";
export { ForwardRef as ReactComponent };